import { Card, Typography } from "antd";
import React from "react";

const { Text, Title } = Typography;

const NoSeason: React.FC = () => {
  return (
    <Card style={{ width: "100%", textAlign: "center", margin: "20px 0" }}>
      <Title level={4}>Det finnes ingen åpen bookingsesong</Title>
      <Text>
        Bookingen for neste semester er ikke klar enda. Dersom din bedrift ønsker påminnelse når bookingen åpner, ta
        kontakt på <a href="mailto:bedrift@bindeleddet.no">bedrift@bindeleddet.no</a>.
      </Text>
    </Card>
  );
};

export default NoSeason;
